import { Reducer } from "redux";

import { RationaleTemplateResponse } from "../models/Api/RationaleTemplate";
import { RationaleTemplateDispatchTypes } from "../models/DispatchTypes/RationaleTemplate";
import { RationaleTemplateActionDispatchTypes } from "../constants/RationaleTemplate";

export const initialState: RationaleTemplateResponse = {
  loading: false,
  response: {
    rationaleTemplateId: "-1",
    serviceRequestType: "",
    rationaleDecision: "",
    discipline: "",
    rationale: "",
    templateName: "",
    resourceDescription: "",
    isActive: false,
    userCreated: ""
  },
};

const PutRationaleTemplateReducer: Reducer<
  RationaleTemplateResponse,
  RationaleTemplateDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case RationaleTemplateActionDispatchTypes.PUT_RATIONALE_TEMPLATE_FORM_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case RationaleTemplateActionDispatchTypes.PUT_RATIONALE_TEMPLATE_FORM_ERROR:
    case RationaleTemplateActionDispatchTypes.PUT_RATIONALE_TEMPLATE_FORM_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case RationaleTemplateActionDispatchTypes.PUT_RATIONALE_TEMPLATE_FORM_RESET: {
      return {
        response: initialState.response,
        loading: false,
      };
    }
  }
  return state;
};

export default PutRationaleTemplateReducer;
